import type { AbsensiStatus, PenyetujuanAktivitas } from "./types";

export const STATUS_META: Record<
  AbsensiStatus,
  { label: string; className: string }
> = {
  tepat: { label: "Tepat waktu", className: "bg-emerald-100 text-emerald-700" },
  terlambat: { label: "Terlambat", className: "bg-amber-100 text-amber-700" },
  izin: { label: "Izin", className: "bg-sky-100 text-sky-700" },
  alfa: { label: "Alfa", className: "bg-rose-100 text-rose-700" },
};

export const PENYETUJUAN_META: Record<
  PenyetujuanAktivitas,
  { label: string; className: string }
> = {   
  none: { label: "", className: "" },
  pending: { label: "Menunggu persetujuan", className: "bg-slate-100 text-slate-600" },
  approved: { label: "Disetujui", className: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Ditolak", className: "bg-rose-100 text-rose-700" },
};